"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DeleteObjectTaggingInput_1 = require("./DeleteObjectTaggingInput");
var DeleteObjectTaggingOutput_1 = require("./DeleteObjectTaggingOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.DeleteObjectTagging = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "DeleteObjectTagging",
    http: {
        method: "DELETE",
        requestUri: "/{Bucket}/{Key+}?tagging"
    },
    input: {
        shape: DeleteObjectTaggingInput_1.DeleteObjectTaggingInput
    },
    output: {
        shape: DeleteObjectTaggingOutput_1.DeleteObjectTaggingOutput
    },
    errors: []
};
//# sourceMappingURL=DeleteObjectTagging.js.map